module.exports = __webpack_public_path__ + "static/media/lounge_ageas_3.55cf0bf6.jpg";